import React, { useEffect } from 'react';

export function SEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} · Tahitian Move`;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
  return null;
}
